






import React from "react";
import { useState } from "react";
import "../../styles/ContactUs.css";
import contactImage from "../../images/contact-slider.jpg";
import officeImage from "../../assets/PuyVastOffice.jpg";
import contactIcon from "../../assets/service-icon.png"; // Import the icon for headers
import { Link } from "react-router-dom";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await fetch("https://site2.akms.org.in/backend/submit-form/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        alert("Form submitted successfully!");
      } else {
        alert(`Error: ${result.error || "Something went wrong!"}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to submit form. Please check console for details.");
    }
  };

  return (
    <div className="contact-container">
      {/* Image Slider */}
      <div className="contact-image-slider">
        <img src={contactImage} alt="Contact Us Slider" />
      </div>

      {/* Contact Section */}
      <div className="contact-content">
        {/* Left Side - Office Image & Address */}
        <div className="office-card">
          {/* Title with Icon - Light blue style with vertical line */}
          <div className="contact-vertical-header">
            <img src={contactIcon} alt="Company Address" className="contact-header-icon rotate-on-hover" />
            <div className="contact-vertical-line"></div>
            <h3 className="contact-header-title">Company Address</h3>
          </div>
          
          <img src={officeImage} alt="PuyVast Office" className="office-image" />
          <div className="address-info">
            <p className="company-name"><strong>Puyvast Logistics Pvt. Ltd.</strong></p>
            <p>"PuyVast House"</p>
            <p>4th Floor ,#6, Harris Road, Benson Town, <br></br>Bangalore - 560 046.</p>
            <p>Email: <a href="mailto:commercial@puyvast.co.in">commercial@puyvast.co.in</a></p>
            <p>Landline : +91 80 23549190</p>
           
          </div>
        </div>

        {/* Right Side - Google Map */}
        <div className="location-map">
          <iframe
            title="Company Location on Google Maps"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3890.1235513893925!2d77.6043214!3d12.9993408!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae11fef32bcd11%3A0x266baf9523efc014!2sPuyVast%20Maritime%20India%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1234567890"
            width="100%"
            height="600"
            style={{ border: "0" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

      {/* Enquiry Form */}
      <div className="enquiry-form">
        {/* Title with Icon - Light blue style with vertical line */}
        <div className="contact-vertical-header">
          <img src={contactIcon} alt="Get in Touch" className="contact-header-icon rotate-on-hover" />
          <div className="contact-vertical-line"></div>
          <h3 className="contact-header-title">Get in Touch</h3>
        </div>
        
        <p>We'd love to assist you! Drop us a message, and our team will get back to you promptly.</p>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-group">
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="subject"
              placeholder="Subject"
              value={formData.subject}
              onChange={handleChange}
              required
            />
          </div>
          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
            required
            className="large-textarea"
          ></textarea>
          <button type="submit" className="enquiry-submit-btn">
            Send Message
          </button>
        </form>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-left">
            <p>CIN Number: U63030KA2022PTC161825</p>
            <p>
              <Link to="/privacy-statement" className="footer-link">Privacy Statement</Link> | 
              <Link to="/terms-of-use" className="footer-link"> Terms Of Use</Link>
            </p>
          </div>
          <div className="footer-center">
            <p>© {new Date().getFullYear()} ONEVEGA Systems (India) Pvt Ltd.</p>
          </div>
          <div className="footer-right">
            <p><strong>Registered Office</strong></p>
            <p>Puyvast Logistics Pvt. Ltd.</p>
            <p>PuyVast House </p>
              <p>4th Floor ,#6, Harris Road, Benson Town, <br></br>Bangalore - 560 046.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContactUs;